import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"gesture-applause"},"children":[{"tag":"g","attrs":{"id":"fill1"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M17.4894 13.9954L19.2042 15.7102L15.0887 19.8257L12.8544 17.5914C12.3087 17.0456 12.0021 16.3054 12.0021 15.5336L12.0021 3.95525C12.0021 3.05519 12.7224 2.32066 13.6222 2.30305C14.4138 2.28757 15.1052 2.83572 15.2706 3.60999L17.4894 13.9954Z"}},{"tag":"path","attrs":{"fill":"props.fillColor1","d":"M6.50898 13.9954L4.79419 15.7102L8.9097 19.8257L11.144 17.5914C11.6897 17.0456 11.9963 16.3054 11.9963 15.5336L11.9963 3.95525C11.9963 3.05519 11.276 2.32066 10.3761 2.30305C9.58455 2.28757 8.8932 2.83572 8.72778 3.60999L6.50898 13.9954Z"}}]},{"tag":"g","attrs":{"id":"fill2"},"children":[{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M19.2044 15.71L15.0889 19.8255L17.1466 21.8832L21.2621 17.7677L19.2044 15.71Z"}},{"tag":"path","attrs":{"fill":"props.fillColor2","d":"M4.79408 15.71L8.90959 19.8255L6.85184 21.8832L2.73633 17.7677L4.79408 15.71Z"}}]},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19.2041 15.7102L17.4893 13.9954L15.2705 3.60999C15.1051 2.83572 14.4137 2.28757 13.6221 2.30305C12.7223 2.32066 12.002 3.05519 12.002 3.95525L12.002 15.5336C12.002 16.3054 12.3086 17.0456 12.8543 17.5914L15.0886 19.8257M19.2041 15.7102L15.0886 19.8257M19.2041 15.7102L21.2619 17.7679L17.1463 21.8834L15.0886 19.8257M4.79408 15.7102L6.50888 13.9954L8.72767 3.60999C8.89309 2.83572 9.58444 2.28757 10.376 2.30305C11.2759 2.32066 11.9962 3.05519 11.9962 3.95525L11.9962 15.5336C11.9962 16.3054 11.6896 17.0456 11.1439 17.5914L8.90959 19.8257M4.79408 15.7102L8.90959 19.8257M4.79408 15.7102L2.73633 17.7679L6.85184 21.8834L8.90959 19.8257","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M4 3L3 2M4 7L3 8M20 3L21 2M20 7L21 8","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const GestureApplause = Vue.extend<IconProps>({
  name: 'GestureApplauseIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'gesture-applause',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default GestureApplause;
